import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'confirm-dialog',
  templateUrl: 'confirm-dialog.component.html',
  styles: [
    `
      ::ng-deep .dialog-modal {
        --min-height: 260px;
        --height: 280px;
        --width: 94%;
        --border-radius: 12px;
      }
      .btn-td {
        vertical-align: buttom;
      }

      @media only screen and (min-width: 768px) and (min-height: 768px) {
        ::ng-deep .dialog-modal {
          --width: 600px;
        }
      }

      .note {
        background-color: lavender;
        border-radius: 10px;
        padding: 0 15px;
      }
    `,
  ],
})
export class ConfirmDialogComponent implements OnInit {
  label = 'Підтвердити';
  level = 'info';
  title = '';
  message = '';
  color = 'primary';

  get icon() {
    if (this.level === 'error')
      return {
        icon: 'information-circle-outline',
        color: 'red',
      };
    if (this.level === 'warning')
      return {
        icon: 'warning-outline',
        color: 'goldenrod',
      };
    if (this.level === 'info')
      return {
        icon: 'information-circle-outline',
        color: 'grey',
      };

    if (this.level === 'none') {
      return null;
    }
  }

  note: string;
  constructor(private _modalController: ModalController) {}
  ngOnInit(): void {}

  buttonClick(action: string) {
    this._modalController.dismiss({
      isConfirmed: action == 'confirmed',
      note: this.note,
    });
  }
}
